export default __webpack_public_path__ + "static/media/infiniwell_dark_logo.185eb3e8.png";